import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nWrapper } from './I18nWrapper';

export function pReactWrapperDirective() {
  "ngInject";

  let directive = {
    restrict: "E",
    template: '<div class="pReactWrapper"></div>',
    controller: pReactWrapperController,
    controllerAs: "pReactWrapper",
    scope: {
      component: "=?",
      props: "=?"
    },
    bindToController: true
  };

  return directive;
}

class pReactWrapperController {
  constructor($element, $scope) {
    "ngInject";
    window.pReactWrapperController = this;

    this.component = this.component || ($scope.$resolve && $scope.$resolve.component);
    this.root = null;

    $scope.$watchGroup([() => this.component, () => this.props], () => {
      if (this.component) {
        if (this.root)
          this.root.unmount();
        this.root = createRoot($element[0]);
        this.root.render(React.createElement(I18nWrapper, {component: this.component, props: this.props}));
      }
    });
  }
}
